import { useContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import DashboardContext from "../context/DashboardContext";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Container from "@mui/material/Container";
import CreateIcon from "@mui/icons-material/Create";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import Drawer from "@mui/material/Drawer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import EstablishmentCard from "../components/establishments/EstablishmentCard";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";
import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
// import Pagination from '@mui/material/Pagination';
import Stack from "@mui/material/Stack";
import { styled, useTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import {
  fetchAllEstablishments,
  fetchCategories,
  fetchEstablishmentDetails,
  activateOrInactivateEstablishment,
  favoriteEstablishment,
} from "../services";
import { CircularProgress } from "@mui/material";
import { getMyEstablishments } from "../services/SubmitEstablishment";

// CONSTANTE ALFABETO PARA FILTRO POR PRIMEIRA LETRA

const alphabet = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0-9",
];

export default function Establishments() {
  // ESTADOS DA APLICAÇÃO

  const [isFirstRender, setIsFirstRender] = useState(true);
  const [allEstablishments, setAllEstablishments] = useState([]);
  // const [establishmentsAmount, setEstablishmentsAmount] = useState(0);
  const [categoriesList, setCategoriesList] = useState([]);
  const [categorySelected, setCategorySelected] = useState("");
  const [isOnlyInactiveDisplayed, setIsOnlyInactiveDisplayed] = useState(false);
  const [isOnlyFavoritesDisplayed, setIsOnlyFavoritesDisplayed] =
    useState(false);
  const [establishmentSelectedDetails, setEstablishmentSelectedDetails] =
    useState({});
  const [establishmentSelectedId, setEstablishmentSelectedId] = useState("");
  const [establishmentsPage, setEstablishmentsPage] = useState(1);
  const [firstLetterFilterInput, setFirstLetterFilterInput] = useState("");
  const [isFavoriteDialogOpen, setIsFavoriteDialogOpen] = useState(false);
  const [establishmentToBeFavoriteId, setEstablishmentToBeFavoriteId] =
    useState("");
  const [establishmentNameSearch, setEstablishmentNameSearch] = useState("");
  const [myEstablishments, setMyEstablishments] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // IMPORTAÇÕES DO CONTEXTO

  const {
    drawerWidth,
    isEstablishmentDrawerOpen,
    setIsEstablishmentDrawerOpen,
    clientUser,
    clientPassword,
    clientId,
    typeClient,
    admin,
    master,
    qrcodeLink,
    setQrcodeLink,
    nodeToken,
    permissions
  } = useContext(DashboardContext);

  const navigate = useNavigate();
  useEffect(() => {
    if (!permissions?.establishments) {
      navigate("/members");
    }
  }, [navigate]);

  // HOOKS

  const theme = useTheme();
  const navigation = useNavigate();

  // LISTAGEM DE ESTABELECIMENTOS

  // ----- todos os estabelecimentos
  const getAllEstablishments = async () => {
    setIsLoading(true);
    if (typeClient === "cnpj" && !myEstablishments) {
      const establishmentsFetched = await fetchAllEstablishments(
        clientUser,
        clientPassword,
        establishmentsPage,
        isOnlyInactiveDisplayed,
        isOnlyFavoritesDisplayed ? "1" : "0",
        categorySelected,
        firstLetterFilterInput,
        establishmentNameSearch
      );
      setAllEstablishments(establishmentsFetched);
      setIsLoading(false);
    } else if (myEstablishments) {
      setIsLoading(true);
      const establishmentsFetched = await getMyEstablishments({
        token: nodeToken,
        page: establishmentsPage,
      });
      setAllEstablishments(establishmentsFetched);
      setIsLoading(false);
    } else {
      const establishmentsFetched = await fetchAllEstablishments(
        "clubecerto",
        "clubecerto",
        establishmentsPage,
        isOnlyInactiveDisplayed,
        isOnlyFavoritesDisplayed ? "1" : "0",
        categorySelected,
        firstLetterFilterInput,
        establishmentNameSearch
      );
      setAllEstablishments(establishmentsFetched);
      setIsLoading(false);
    }
  };

  // setEstablishmentsAmount(establishmentsFetched.amount);

  // ----- handler paginação dos estabelecimentos / atualmente controlado inline
  // const handleEstablishmentsPagination = async (_event, value) => {
  //   setEstablishmentsPage(value);
  // };

  // DETALHES DE UM ESTABELECIMENTO

  // ----- get dos detalhes de um estabelecimento
  const getEstablishmentDetails = async (establishmentId) => {
    if (typeClient === "cnpj") {
      const details = await fetchEstablishmentDetails(
        clientUser,
        clientPassword,
        establishmentId
      );
      setEstablishmentSelectedDetails(details);
    } else {
      const details = await fetchEstablishmentDetails(
        "clubecerto",
        "clubecerto",
        establishmentId
      );
      setEstablishmentSelectedDetails(details);
    }
  };

  // ----- handler botão de detalhes de um estabelecimento
  const handleClickEstablishment = async ({ currentTarget: { name: id } }) => {
    await getEstablishmentDetails(id);
    setEstablishmentSelectedId(id);
    setIsEstablishmentDrawerOpen(true);
  };

  // ----- handler botão de fechar drawer de detalhes de um estabelecimento
  const handleCloseDrawer = () => {
    setIsEstablishmentDrawerOpen(false);
    setEstablishmentSelectedDetails("");
    setEstablishmentSelectedId("");
  };

  // FILTRO DE CATEGORIAS

  // ----- get da lista de categorias
  const getCategories = async () => {
    if (typeClient === "cnpj") {
      const categories = await fetchCategories(clientUser, clientPassword);
      setCategoriesList(categories);
    } else {
      const categories = await fetchCategories("clubecerto", "clubecerto");
      setCategoriesList(categories);
    }
  };

  // ----- handler do select de categorias
  const handleChangeCategory = async ({ target: { value } }) => {
    setCategorySelected(value);
  };

  // FILTRO POR PRIMEIRA LETRA DO NOME

  // ----- handler dos botões-letras do filtro de primeira letra do nome
  const handleClickLetter = ({ target: { name: letter } }) => {
    setFirstLetterFilterInput(letter);
  };

  const handleFirstLetterFilterReset = () => {
    setFirstLetterFilterInput("");
  };

  // FILTRO POR HABILITADOS/DESABILITADOS

  // ----- handler do switch do filtro de habilitados/desabilitados
  const handleOnlyActivatedFilter = ({ target: { checked } }) => {
    setIsOnlyInactiveDisplayed(!checked);
  };

  // FILTRO POR DESTAQUES

  // ----- handler do switch do filtro de destaques
  const handleOnlyFavoritesFilter = ({ target: { checked } }) => {
    setIsOnlyInactiveDisplayed(false);
    setIsOnlyFavoritesDisplayed(checked);
  };

  // BUSCA PELO NOME DO ESTABELECIMENTO

  // ----- handler do input de nome do estabelecimento
  const handleNameSearchInputChange = ({ target: { value } }) => {
    setEstablishmentNameSearch(value);
  };

  // ----- handler do botão de reset do filtro
  const handleResetFilterButton = () => {
    setEstablishmentsPage(1);
    setEstablishmentNameSearch("");
  };

  // ----- submit do filtro por nome
  const submitNameSearch = async (event) => {
    event.preventDefault();
    setEstablishmentsPage(1);
    await getAllEstablishments();
  };

  // ATIVAÇÃO DE UM ESTABELECIMENTO

  // ----- ativa/desativa estabelecimento
  const handleActivateEstablishment = async ({
    currentTarget: { name: id },
  }) => {
    const updatedEstablishment = await activateOrInactivateEstablishment(id);
    await getAllEstablishments();

    setEstablishmentSelectedDetails(updatedEstablishment);
  };

  // ATIVAÇÃO DE UM ESTABELECIMENTO COMO DESTAQUE

  // ----- abre e fecha dialog de confirmação do destaque do estabelecimento
  const handleFavoriteDialog = ({ currentTarget: { name: id } }) => {
    if (!!id) setEstablishmentToBeFavoriteId(id);
    setIsFavoriteDialogOpen(!isFavoriteDialogOpen);
  };

  // ----- ativa/desativa estabelecimento como destaque
  const handleFavoriteEstablishment = async () => {
    setIsFavoriteDialogOpen(!isFavoriteDialogOpen);
    const updatedEstablishment = await favoriteEstablishment(
      clientUser,
      clientPassword,
      establishmentToBeFavoriteId
    );
    await getAllEstablishments();
    setEstablishmentSelectedDetails(updatedEstablishment);
  };

  // USE EFFECTS

  // ----- quando a página carrega
  useEffect(() => {
    let isMounted = true;
    getAllEstablishments();
    getCategories();
    setIsEstablishmentDrawerOpen(false);
    setIsFirstRender(false);
    return () => { isMounted = false };
  }, []);

  // ----- quando a paginação do grid de estabelecimentos é alterada
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) getAllEstablishments();
    return () => { isMounted = false };
  }, [establishmentsPage]);

  // ----- quando a categoria é alterada
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      getAllEstablishments();
      setEstablishmentsPage("1");
    }
    return () => { isMounted = false };
  }, [categorySelected]);

  // ----- quando um botão-letra do filtro de primeira letra é clicado
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      getAllEstablishments();
      setEstablishmentsPage("1");
    }
    return () => { isMounted = false };
  }, [firstLetterFilterInput]);
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      getAllEstablishments();
      setEstablishmentsPage("1");
    }
    return () => { isMounted = false };
  }, [myEstablishments]);

  // ----- quando o switch do filtro ativos/inativos é clicado
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      getAllEstablishments();
      setEstablishmentsPage("1");
    }
    return () => { isMounted = false };
  }, [isOnlyInactiveDisplayed]);

  // ----- quando o switch do filtro destaques é clicado
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      getAllEstablishments();
      setEstablishmentsPage("1");
    }
    return () => { isMounted = false };
  }, [isOnlyFavoritesDisplayed]);

  // ----- quando establishmentNameSearch é resetado
  useEffect(() => {
    let isMounted = true;
    if (!isFirstRender) {
      if (establishmentNameSearch === "") {
        getAllEstablishments();
      }
    }
    return () => { isMounted = false };
  }, [establishmentNameSearch]);

  // COMPONENTE MAIN

  const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: 0,
      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: +drawerWidth,
      }),
    })
  );

  // RETORNO

  return (
    <>
      {/* CONFIRMAÇÃO ATIVAR/DESATIVAR ASSOCIADO */}
      <Dialog
        open={isFavoriteDialogOpen}
        onClose={handleFavoriteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Tem certeza dessa ação?
        </DialogTitle>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button color="error" onClick={handleFavoriteDialog}>
            Cancelar
          </Button>
          <Button onClick={handleFavoriteEstablishment}>Concordar</Button>
        </DialogActions>
      </Dialog>

      {/* CONTAINER PRINCIPAL EXTERNO */}
      {
        // !!allEstablishments.length && (
        <Main open={!!isEstablishmentDrawerOpen} sx={{ p: 0 }}>
          <Container sx={{ minWidth: 800 }}>
            <Stack spacing={3} mb={3}>
              {/* BOTÃO DE CADASTRAR E FILTRO POR PRIMEIRA LETRA */}
              <Container
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* BOTÃO DE CADASTRAR NOVO ESTABELECIMENTO */}
                <CustomButton
                  color="primary"
                  disabled={admin || master === true ? false : true}
                  onClick={() => navigation("/new-establishment")}
                  sx={{
                    alingItems: "center",
                    display: "flex",
                    minWidth: "300px",
                  }}
                  type="button"
                  variant="contained"
                >
                  <Typography sx={{ lineHeight: 1.5 }} variant="button">
                    Cadastrar Estabelecimento
                  </Typography>
                  <CreateIcon sx={{ ml: 1 }} />
                </CustomButton>

                {/* FILTRO POR PRIMEIRA LETRA */}
                <Box
                  sx={{ alignItems: "center", display: "flex", height: "40px" }}
                >
                  {/* BOTÃO DE RESET DO FILTRO */}
                  {!!firstLetterFilterInput && (
                    <Tooltip title="Descartar filtro">
                      <IconButton
                        onClick={handleFirstLetterFilterReset}
                        sx={{ mr: 1, p: 0 }}
                      >
                        <CloseIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  )}

                  {/* BOTÕES DO FILTRO POR PRIMEIRA LETRA */}
                  {alphabet.map((letter) => (
                    <Button
                      color={
                        firstLetterFilterInput === letter
                          ? "carbonGray"
                          : "primary"
                      }
                      disabled
                      key={letter}
                      name={letter}
                      onClick={handleClickLetter}
                      sx={{
                        height: "40px",
                        lineHeight: "40px",
                        minWidth: `${letter === "0-9" ? "25px" : "15px"}`,
                        p: 0,
                      }}
                    >
                      {letter}
                    </Button>
                  ))}
                </Box>
              </Container>

              {/* CONTAINER PRINCIPAL INTERNO */}
              <CustomContainer
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  py: 3,
                }}
              >
                {/* FILTROS POR NOME, ATIVO/INATIVO, DESTAQUE E CATEGORIA */}
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 3,
                    px: 6,
                  }}
                >
                  {/* FILTRO POR NOME */}
                  <form onSubmit={submitNameSearch} style={{ width: "100%" }}>
                    <Stack
                      direction={isEstablishmentDrawerOpen ? "column" : "row"}
                      spacing={1}
                    >
                      <CustomTextField
                        autoComplete="off"
                        color="primary"
                        label="Digite aqui"
                        name="textInput"
                        onChange={handleNameSearchInputChange}
                        size="small"
                        sx={{ width: "180px" }}
                        type="text"
                        value={establishmentNameSearch}
                        variant="outlined"
                      />

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: `${!isEstablishmentDrawerOpen ? "100px" : "180px"
                            }`,
                        }}
                      >
                        <Tooltip title="Filtrar">
                          <CustomButton
                            color="primary"
                            sx={{ maxWidth: "40px", minWidth: "40px", mr: 1 }}
                            type="submit"
                            variant="contained"
                          >
                            <FilterAltIcon />
                          </CustomButton>
                        </Tooltip>

                        <Tooltip title="Descartar filtro">
                          <CustomButton
                            color="error"
                            onClick={handleResetFilterButton}
                            sx={{ maxWidth: "40px", minWidth: "40px" }}
                            type="button"
                            variant="contained"
                          >
                            <ClearIcon />
                          </CustomButton>
                        </Tooltip>
                      </Box>
                    </Stack>
                  </form>

                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {/* FILTRO POR ATIVO/INATIVO */}
                    <Box sx={{ alignItems: "center", display: "flex" }}>
                      <Typography>Desabilitados</Typography>
                      <Switch
                        checked={!isOnlyInactiveDisplayed}
                        color="primary"
                        // disabled={ isOnlyFavoritesDisplayed } lógica para filtro de desabilitados não interferir com favoritos
                        disabled
                        onChange={handleOnlyActivatedFilter}
                      />
                      <Typography>Habilitados</Typography>
                    </Box>

                    {/* FILTRO POR DESTAQUE */}
                    {clientId === "1184" && (
                      <Box sx={{ alignItems: "center", display: "flex" }}>
                        <Typography>Todos</Typography>
                        <Switch
                          checked={isOnlyFavoritesDisplayed}
                          color="primary"
                          onChange={handleOnlyFavoritesFilter}
                        />
                        <Typography>Destaques</Typography>
                      </Box>
                    )}
                  </Box>

                  {/* FILTRO POR CATEGORIA */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <CustomTextField
                      color="primary"
                      label="Categoria"
                      name="categoryFilter"
                      onChange={handleChangeCategory}
                      select
                      size="small"
                      sx={{ width: "180px" }}
                      value={categorySelected}
                      variant="outlined"
                    >
                      <MenuItem value="">Todas</MenuItem>
                      {!!categoriesList &&
                        categoriesList.map(({ Nome, Codigo }) => (
                          <MenuItem key={Codigo + Nome} value={Codigo}>
                            {Nome}
                          </MenuItem>
                        ))}
                    </CustomTextField>
                  </Box>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "18px",
                        color: " #333",

                        display: "flex",
                      }}
                    >
                      Indicações
                    </label>
                    <input
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #333",
                        borderRadius: "5px",
                        outline: "none",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      checked={myEstablishments}
                      onChange={({ currentTarget }) => {
                        setMyEstablishments(currentTarget.checked);
                      }}
                      type="checkbox"
                      id={"myEstablishmentsID"}
                    />
                  </div>
                </Box>

                {/* GRID DE ESTABELECIMENTOS */}
                <Grid container spacing={4}>
                  {isLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: 2,
                        width: "100%",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : !allEstablishments ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: 2,
                        width: "100%",
                      }}
                    >
                      <Typography component="p" mt={4} variant="h4">
                        Estabelecimento não encontrado
                      </Typography>
                    </Box>
                  ) : allEstablishments && !myEstablishments ? (
                    allEstablishments?.map(
                      ({ Codigo, Nome, CategoriaNome, Marca, Ativo }) => (
                        <Grid key={Codigo + Nome} item xs={2.4}>
                          <EstablishmentCard
                            id={Codigo}
                            name={Nome || ""}
                            cover={Marca}
                            category={CategoriaNome || ""}
                            isDisabled={!Number(Ativo)}
                            handler={handleClickEstablishment}
                            selectedId={establishmentSelectedId}
                          />
                        </Grid>
                      )
                    )
                  ) : (
                    allEstablishments?.map(
                      ({ id, name, image, approved, disapproved, cover }) => (
                        <Grid key={id + name} item xs={2.4}>
                          <EstablishmentCard
                            id={id}
                            name={name || "Indefinido"}
                            cover={image || cover}
                            category={
                              approved
                                ? "Aprovado"
                                : disapproved
                                  ? "reprovado"
                                  : "Pendente"
                            }
                            isDisabled={0}
                            handler={() => console.log(id)}
                            selectedId={establishmentSelectedId}
                            type={
                              approved
                                ? "approved"
                                : disapproved
                                  ? "disapproved"
                                  : "pedency"
                            }
                          />
                        </Grid>
                      )
                    )
                  )}
                </Grid>

                {/* PAGINAÇÃO DE ESTABELECIMENTOS */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 4,
                    maxWidth: "100%",
                  }}
                >
                  <ButtonGroup size="small">
                    {/* BOTÃO PARA PRIMEIRA PÁGINA */}
                    <CustomButton
                      onClick={() => {
                        setIsLoading(true);
                        setEstablishmentsPage("1");
                      }}
                      variant="contained"
                    >
                      <FirstPageRoundedIcon />
                    </CustomButton>

                    {/* BOTÃO PARA PÁGINA ANTERIOR */}
                    <CustomButton
                      onClick={() => {
                        if (Number(establishmentsPage) > 1) {
                          setIsLoading(true);
                          setEstablishmentsPage((prev) =>
                            (Number(prev) - 1).toString()
                          );
                        }
                      }}
                      variant="contained"
                    >
                      <NavigateBeforeRoundedIcon />
                    </CustomButton>

                    {/* BOTÃO PARA PRÓXIMA PÁGINA */}
                    <CustomButton
                      onClick={() => {
                        setIsLoading(true);
                        setEstablishmentsPage((prev) =>
                          (Number(prev) + 1).toString()
                        );
                      }}
                      variant="contained"
                    >
                      <NavigateNextRoundedIcon />
                    </CustomButton>
                  </ButtonGroup>
                  <Box
                    sx={{
                      alignItems: "center",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "0px 0px 15px 0px rgb(88 88 88 / 30%)",
                      display: "flex",
                      heigth: "40px",
                      justifyContent: "center",
                      ml: 1,
                      width: "40px",
                    }}
                  >
                    <Typography color="primary" component="p" variant="h6">
                      {establishmentsPage}
                    </Typography>
                  </Box>
                </Box>

                {/* PAGINAÇÃO ANTIGA DE ESTABELECIMENTOS */}
                {/* <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 4, maxWidth: "100%" }}>
                    { (!!establishmentsAmount && !isOnlyFavoritesDisplayed) && <Pagination
                      color="primary"
                      count={
                        isOnlyActiveDisplayed
                        ? Math.ceil(establishmentsAmount.ativos/allEstablishments.length)
                        : Math.ceil(establishmentsAmount.inativos/allEstablishments.length)
                      }
                      onChange={handleEstablishmentsPagination}
                      page={establishmentsPage}
                      size="small"
                    /> }
                  </Box> */}
              </CustomContainer>
            </Stack>
          </Container>
        </Main>
        // )
      }
      {/* DRAWER DE DETALHES DO ESTABELECIMENTO */}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="right"
        open={!!isEstablishmentDrawerOpen}
      >
        {/* ESPAÇAMENTO DO HEADER */}
        <Toolbar sx={{ height: "68.5px" }} />

        {/* NOME E BOTÃO PARA RECOLHER */}
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            py: 1,
          }}
        >
          {/* BOTÃO DE RECOLHER */}
          <IconButton onClick={handleCloseDrawer} sx={{ m: 1 }}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>

          {/* NOME DO ESTABELECIMENTO */}
          <Box
            sx={{
              alignItems: "flex-end",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {!!establishmentSelectedDetails && (
              <Typography
                color="primary"
                component="h4"
                fontWeight={600}
                px={1}
                variant="h5"
              >
                {`${establishmentSelectedDetails.Nome}`}
              </Typography>
            )}
          </Box>
        </Box>

        {!!establishmentSelectedDetails && (
          <Stack px={2} py={1} spacing={2}>
            {/* LOGO E CARDS DE INFORMAÇÕES DO ESTABELECIMENTO */}
            <Stack direction="row" spacing={2} alignItems="center">
              {/* LOGO */}
              <Box
                sx={{
                  backgroundImage: `url(${establishmentSelectedDetails.Marca})`,
                  backgroundClip: "border-box",
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                  borderRadius: "30px",
                  boxShadow: "0px 0px 15px 0px rgb(88 88 88 / 20%)",
                  height: "160px",
                  maxWidth: "160px",
                  minWidth: "160px",
                }}
              />

              {/* CATEGORIA, EXCLUSIVO */}
              <Stack spacing={2} sx={{ width: "100%" }}>
                {/* CATEGORIA */}
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    <Typography color="primary">Categoria:</Typography>
                    <Typography>
                      {establishmentSelectedDetails.CategoriaNome || "-"}
                    </Typography>
                  </Box>
                </CustomContainer>

                {/* EXCLUSIVO */}
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    <Typography color="primary">Exclusivo:</Typography>
                    <Typography>
                      {!Number(establishmentSelectedDetails.Exclusivo)
                        ? "Não"
                        : "Sim"}
                    </Typography>
                  </Box>
                </CustomContainer>
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography fontSize="0.875rem">
                    {/* { !Number(establishmentSelectedDetails.Ativo) ? "Estabelecimento desabilitado" : "Estabelecimento habilitado" } */}
                    É destaque ?
                  </Typography>
                  <Switch
                    // checked={ !!Number(establishmentSelectedDetails.Ativo) }
                    checked={true}
                    color="primary"
                    disabled
                    name={establishmentSelectedDetails.id}
                    onChange={handleActivateEstablishment}
                  />
                </CustomContainer>
              </Stack>

              {/* ONLINE, VOUCHER */}
              <Stack spacing={2} sx={{ width: "100%" }}>
                {/* LOJA ONLINE */}
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    <Typography color="primary">Loja Online:</Typography>
                    <Typography>
                      {!Number(establishmentSelectedDetails.online)
                        ? "Não"
                        : "Sim"}
                    </Typography>
                  </Box>
                </CustomContainer>

                {/* VOUCHER */}
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    <Typography color="primary">Voucher:</Typography>
                    <Typography>
                      {establishmentSelectedDetails.Voucher || "-"}
                    </Typography>
                  </Box>
                </CustomContainer>
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Link
                    component="a"
                    onClick={() => {
                      sessionStorage.setItem(
                        "qrcodeLink",
                        `https://www.clubecerto.com.br/oferta?utm_cc_search=busca&e=${establishmentSelectedId}`
                      );
                      setQrcodeLink(
                        `https://www.clubecerto.com.br/oferta?utm_cc_search=busca&e=${establishmentSelectedId}`
                      );
                      navigation("/qrcode");
                    }}
                    rel="noopener"
                    sx={{ width: "100%", cursor: "pointer" }}
                    target="_blank"
                    textAlign="center"
                    underline="hover"
                    variant="h6"
                  >
                    Ver QRcode
                  </Link>
                </CustomContainer>
              </Stack>
            </Stack>

            {/* ATIVAR/INATIVAR, DESTAQUE E LINK SITE */}
            <Stack direction="row" spacing={2}>
              {/* ATIVAR/INATIVAR ESTABELECIMENTO */}
              <CustomContainer
                sx={{
                  alignItems: "center",
                  borderRadius: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Typography fontSize="0.875rem">
                  {/* { !Number(establishmentSelectedDetails.Ativo) ? "Estabelecimento desabilitado" : "Estabelecimento habilitado" } */}
                  Estabelecimento habilitado
                </Typography>
                <Switch
                  // checked={ !!Number(establishmentSelectedDetails.Ativo) }
                  checked={true}
                  color="primary"
                  disabled
                  name={establishmentSelectedDetails.id}
                  onChange={handleActivateEstablishment}
                />
              </CustomContainer>

              {/* ATIVAR/INATIVAR DESTAQUE */}
              {clientId === "1184" && (
                <CustomContainer
                  sx={{
                    alignItems: "center",
                    borderRadius: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography fontSize="0.875rem">
                    {!Number(establishmentSelectedDetails.Carrousel)
                      ? "Estabelecimento não é destaque"
                      : "Estabelecimento é destaque"}
                  </Typography>
                  <Switch
                    checked={!!Number(establishmentSelectedDetails.Carrousel)}
                    color="primary"
                    name={establishmentSelectedDetails.Codigo}
                    onChange={handleFavoriteDialog}
                  />
                </CustomContainer>
              )}

              {/* LINK SITE */}
              <CustomContainer
                m={1}
                sx={{
                  alignItems: "center",
                  borderRadius: "20px",
                  display: "flex",
                  justifycontent: "center",
                }}
              >
                {establishmentSelectedDetails.Linksite ? (
                  <Link
                    component="a"
                    href={establishmentSelectedDetails.Linksite}
                    rel="noopener"
                    sx={{ width: "100%" }}
                    target="_blank"
                    textAlign="center"
                    underline="hover"
                    variant="h6"
                  >
                    Link do site
                  </Link>
                ) : (
                  <Typography sx={{ width: "100%" }} textAlign="center">
                    {"Link do site"}
                    <br />
                    {"-"}
                  </Typography>
                )}
              </CustomContainer>
            </Stack>

            {/* SOBRE */}
            {!!establishmentSelectedDetails.Sobre &&
              establishmentSelectedDetails.Sobre.length !== 0 && (
                <CustomContainer m={1} sx={{ borderRadius: "15px" }}>
                  <Box sx={{ display: "flex" }}>
                    <Typography color="primary" sx={{ mr: 1 }}>
                      Sobre:
                    </Typography>
                    <Typography>
                      {establishmentSelectedDetails.Sobre}
                    </Typography>
                  </Box>
                </CustomContainer>
              )}

            {/* BENEFÍCIOS */}
            {!!establishmentSelectedDetails.Beneficios &&
              establishmentSelectedDetails.Beneficios.length !== 0 && (
                <Stack spacing={1}>
                  <Typography color="primary" fontWeight={600} ml={2} my={0.5}>
                    Benefícios:
                  </Typography>
                  {establishmentSelectedDetails.Beneficios.map(
                    ({ desconto, regra }, index) => (
                      <CustomContainer
                        key={index}
                        m={1}
                        sx={{ borderRadius: "15px" }}
                      >
                        <Box sx={{ display: "flex", mb: 1 }}>
                          <Typography
                            color="primary"
                            sx={{ mr: 1, width: "73px" }}
                          >
                            Desconto:
                          </Typography>
                          <Typography>{desconto}</Typography>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            color="primary"
                            sx={{ mr: 1, minWidth: "73px" }}
                          >
                            Regra:
                          </Typography>
                          <Typography>{regra}</Typography>
                        </Box>
                      </CustomContainer>
                    )
                  )}
                </Stack>
              )}
          </Stack>
        )}
      </Drawer>
    </>
  );
}
